import { Outlet } from 'react-router-dom';
import { getTenantSubdomain } from '../services/api';
import './Login.css';

/**
 * Shared layout for login, register, forgot-password, reset-password.
 * Renders a single fixed banner background so it does not move when switching between auth pages.
 * RS tenant: no banner image (plain background).
 */
const AuthLayout = () => {
  const isRsTenant = (getTenantSubdomain() || '').toLowerCase() === 'rs';
  const bannerUrl = `${process.env.PUBLIC_URL || ''}/banner.png`;

  const bgStyle = isRsTenant
    ? { backgroundImage: 'none', backgroundColor: '#2a2a2a' }
    : { backgroundImage: `url('${bannerUrl}')` };

  return (
    <div className="auth-layout">
      {/* Fixed background - stays in place when navigating between auth pages */}
      <div
        className="auth-bg"
        style={bgStyle}
        aria-hidden="true"
      />
      <div className="auth-overlay" aria-hidden="true" />
      <div className="login-container">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
